import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Message } from '../../../subcomponents/message/message';
import { MemberJourneyListContextInstance } from '../types/context';
export var MemberJourneyListMessageType;
(function (MemberJourneyListMessageType) {
    MemberJourneyListMessageType["NoUpcomingJourneys"] = "NoUpcomingJourneys";
    MemberJourneyListMessageType["NoRecentJourneys"] = "NoRecentJourneys";
    MemberJourneyListMessageType["FailedToLoadData"] = "FailedToLoadData";
})(MemberJourneyListMessageType || (MemberJourneyListMessageType = {}));
export const MemberJourneyListMessage = observer(props => {
    const { messageType, children } = props;
    const { displayText, assets } = useContext(MemberJourneyListContextInstance);
    return (_jsx(Message, Object.assign({}, getMemberJourneyListMessageProps(messageType, assets, displayText), { className: 'v-member-journey-list-message' }, { children: children })));
});
MemberJourneyListMessage.displayName = 'MemberJourneyListMessage';
const getMemberJourneyListMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case MemberJourneyListMessageType.NoUpcomingJourneys:
            return {
                iconName: assets.noJourneysIconName,
                title: displayText.noActiveJourneysTitle,
                description: displayText.noActiveJourneysMessage
            };
        case MemberJourneyListMessageType.NoRecentJourneys:
            return {
                iconName: assets.noJourneysIconName,
                title: displayText.noRecentJourneysTitle,
                description: displayText.noRecentJourneysMessage
            };
        case MemberJourneyListMessageType.FailedToLoadData:
        default:
            return {
                iconName: assets.failedToLoadJourneysIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
    }
};
